import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Header } from "@/components/Header";
import { ResultsDashboard } from "@/components/ResultsDashboard";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { AlertCircle, ArrowLeft } from "lucide-react";

export default function ReportPage() {
  const { id } = useParams();
  const { t } = useI18n();
  const [audit, setAudit] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const { data } = await api.get(`/audits/${id}`);
        if (alive) setAudit(data);
      } catch (e) {
        if (alive) setError(e?.response?.status === 404 ? "not_found" : "error");
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, [id]);

  return (
    <div data-testid="report-page" className="min-h-screen bg-[color:var(--impact-bg)]">
      <Header />
      {loading && (
        <div className="max-w-3xl mx-auto px-6 py-24 text-center">
          <div className="eyebrow mb-3">Impact Audit AI</div>
          <div className="font-display text-2xl text-[color:var(--impact-ink)]">
            {t("report.loading") === "report.loading" ? "Chargement de votre rapport…" : t("report.loading")}
          </div>
        </div>
      )}
      {error && (
        <div className="max-w-2xl mx-auto px-6 py-24">
          <div className="impact-card p-10 text-center">
            <AlertCircle size={40} className="mx-auto mb-4 text-[color:var(--impact-high)]" />
            <h2 className="font-display font-bold text-2xl mb-2">
              {error === "not_found" ? "Rapport introuvable" : "Erreur de chargement"}
            </h2>
            <p className="text-[color:var(--impact-ink-2)] mb-6">
              {error === "not_found"
                ? "Ce rapport n'existe plus ou l'identifiant est invalide."
                : "Une erreur est survenue. Réessayez dans un instant."}
            </p>
            <Link to="/" className="btn-primary btn-brand inline-flex" data-testid="back-home-link">
              <ArrowLeft size={16} /> Retour à l'accueil
            </Link>
          </div>
        </div>
      )}
      {audit && !error && <ResultsDashboard audit={audit} />}
    </div>
  );
}
